<flex-select-tree-input #flexSelectTreeInput [nodes]="userNodes" [placeholder]="placeholder" [multiple]="multiple"
  (selectionChange)="onSelectionChange($event)"
  [showCheckAll]="showCheckAll" [formControl]="myControl">
</flex-select-tree-input>
